// Moved from src/features/ContactsFeature/api/contactsApi.js, with its
// duplicate create/update/delete endpoints DROPPED - they collided
// (identical bodies, same endpoint names) with
// `_features/contacts/api/contactApiSlice.js` injecting onto the same
// shared apiSlice, and every real create/update/
// delete call site already imports from that fat, genuinely-shared slice
// (4 external consumers beyond this feature). Keeping both was two
// competing sources of truth for no benefit - this file now owns exactly
// the two list-query endpoints that were actually this lean slice's own.
// Real cache tags added (neither slice had any before).
import { apiRoutes } from "../../../_config/apiRoutes";
import { apiSlice } from "../../../_api/apiSlice";

export const contactsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllContacts: builder.query({
      query: (params) => ({
        url: apiRoutes.contact.get.path,
        method: apiRoutes.contact.get.reqType,
        params,
      }),
      providesTags: ["Contacts"],
    }),
    // Stat cards and tab counts, computed over every contact on the server.
    getContactsOverview: builder.query({
      query: () => ({
        url: apiRoutes.contact.overview.path,
        method: apiRoutes.contact.overview.reqType,
      }),
      providesTags: ["Contacts"],
    }),
    // Searchable, paginated contact picker (excludes contacts already on a company).
    searchContacts: builder.query({
      query: (params) => ({
        url: apiRoutes.contact.picker.path,
        method: apiRoutes.contact.picker.reqType,
        params,
      }),
      providesTags: ["Contacts"],
    }),
    getContactsByOrgId: builder.query({
      query: (params) => ({
        url: apiRoutes.contact.getByOrgId.path,
        method: apiRoutes.contact.getByOrgId.reqType,
        params,
      }),
      providesTags: ["Contacts"],
    }),
  }),
});

export const { useGetAllContactsQuery, useGetContactsByOrgIdQuery, useGetContactsOverviewQuery, useSearchContactsQuery } = contactsApiSlice;
